/* istanbul ignore file */
import React, { useEffect, useRef } from 'react'
import { hooks as coreHooks } from '@adc/ui-core'
import ChatUtils, { ChatVariants } from '../../shared/util/chatUtils'
import { useApplicationContext } from '../auctionApplication/context'

const ChatButton = ({
  variant = ChatVariants.Default,
}: {
  variant?: ChatVariants
}) => {
  const { user }: { user: any } = useApplicationContext()
  const canV2ChatLoad =
    typeof window !== 'undefined' && typeof document?.body !== 'undefined'

  // Storing user in a ref because the reference is outdated  when passing
  // onButtonClicked otherwise
  const userRef = useRef(user)
  coreHooks.useMountEffect(() => {
    if (canV2ChatLoad) {
      ChatUtils.loadSalesforceV2Chat(onButtonClicked, variant, user)
    }
  })

  useEffect(() => {
    userRef.current = user
    if (user.logged_in) {
      const { email, first_name, last_name } = user
      ChatUtils.setUserChatInfo(first_name, last_name, email)
    }
  }, [user])

  const onButtonClicked = function () {
    const { email, first_name, last_name } = userRef.current
    ChatUtils.setUserChatInfo(first_name, last_name, email)
    ChatUtils.setVisibleUserChatInfo(first_name, last_name, email)
  }

  return <div data-elm-id='salesforce-v2-chat' />
}

export default ChatButton
